<div style="position:relative; top: 6px;" data-cy="tdo-accordion-item-header-container">
  <ng-content></ng-content>
</div>
